import { useEffect, useRef } from 'react';
import useAuthentication from '../hooks/useAuthentication';

const KIOSK_MODE_KEY = "lansingnow_kiosk_mode";

export function isKioskMode(): boolean {
  return localStorage.getItem(KIOSK_MODE_KEY) === "True";
}

export default function KioskManager(onLogout: () => void, logoutMinutes: number) {

  // Set kiosk storage item in case utm_source=kiosk is detected
  const query = new URLSearchParams(window.location.search);
  if (query.get('utm_source') === "kiosk")
    localStorage.setItem(KIOSK_MODE_KEY, "True");

  const { isAuthenticated } = useAuthentication();
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const kioskMode = isKioskMode();

  // Push kiosk GTM data layer variable
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({
      Var_is_kiosk: kioskMode
  });

  // Auto logout events and logic below
  const resetTimer = () => {
    // Checkout page auto logout period is shorter compared to rest of the app
    let timerMinutes = logoutMinutes;

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      onLogout();
    }, timerMinutes * 60 * 1000);
  };

  useEffect(() => {
    // If visitor or not in kiosk mode or not on checkout completed page, no auto-logout needed
    if (!isAuthenticated || !kioskMode || !document.location.pathname.startsWith('/checkout/completed'))
      return;

    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

    const handleActivity = () => resetTimer();

    events.forEach(event => {
      window.addEventListener(event, handleActivity);
    });

    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [isAuthenticated, kioskMode]);
}
